import React from "react";
import { createUseStyles } from "react-jss";
import { bootstrap } from "toetag";
import Icon from "./icon";
import transitionStyles from "../transition-styles";
const Alert = _ref => {
  let {
    type = "info",
    children,
    headline,
    onDismiss,
    dismissTitle = "Dismiss",
    showIcon = true,
    classes: classOverrides
  } = _ref;
  let classes = useStyles();
  classes = {
    ...classes,
    ...classOverrides
  };
  const isDismissable = !!onDismiss;
  const css = `${isDismissable ? classes.dismissable : ""} ${classes[type]} ${classes.alert}`;
  const dismiss = isDismissable ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classes.close,
    title: dismissTitle,
    onClick: onDismiss
  }, "\xD7") : null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: css
  }, dismiss, showIcon ? /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon,
    type: type
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.msgContainer
  }, headline ? /*#__PURE__*/React.createElement("h4", {
    className: classes.headline
  }, headline) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.body
  }, children))));
};
const useStyles = createUseStyles({
  ...transitionStyles,
  alert: {
    composes: "alert",
    marginBottom: bootstrap.paddingBaseVertical,
    display: "inline-block",
    textAlign: "left"
  },
  info: {
    composes: "alert-info"
  },
  success: {
    composes: "alert-success"
  },
  warning: {
    composes: "alert-warning"
  },
  danger: {
    composes: "alert-danger"
  },
  dismissable: {
    composes: "alert-dismissable"
  },
  close: {
    composes: "close"
  },
  msgContainer: {
    display: "inline-block"
  },
  icon: {
    verticalAlign: "top",
    fontSize: bootstrap.fontSizeH4,
    paddingRight: bootstrap.paddingLargeHorizontal,
    opacity: 0.2
  },
  headline: {
    margin: 0,
    marginBottom: bootstrap.paddingBaseVertical
  },
  body: {
    maxWidth: "40em"
  }
});
export default Alert;